import { getSensorByPrimitiveUuid, queryCameraPlay, sendMsgToAiServer, sendRangeToAiServer } from "@/api/device/sensor";
import { Sensor } from "@/global/interface/device/sensor";
import { useEffect, useState } from "react";
import "./index.less";
import { ReactComponent as SwitchImgAndVideoSvg } from '@/global/icons/srceen/switch-img-and-video.svg';
import { message, Tooltip } from "antd";
import { getMonitorObjectsBySensorId } from "@/api/monitor-object/monitor-object";
import { MonitorObject } from "@/global/interface/monitor-object/monitor-object";
import MonitorCurvePanel from "./monitor-curve-panel";
import MonitorSettingPanel from "./monitor-setting";
import { MonitorImagePanel } from "./monitor-image";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { MonitorVideoPanel } from "./monitor-video";
import { DragModal } from "tncet-common";
import { Base64ImageCanvas } from "@/global/components/base64-img-canvas";
import { MonitorInvasionPanel } from "./monitor-invasion";
import { useParams } from "react-router-dom";
import classNames from "classnames";

interface IProps {
    entityUuid: string
}

enum ShowType {
    video = 1,    //视频
    displacement, //位移图
    invasion      //异物入侵图
}

export default function MonitorRightMainPanel(props: IProps) {

    const { projectId } = useParams();

    const [sensor, setSensor] = useState<Sensor>(null)         // 传感器
    const [url, setUrl] = useState<string>(null)               //视频流地址
    const [showType, setShowType] = useState<ShowType>(ShowType.displacement); //是否显示视频

    const [mobjects, setMobjects] = useState<MonitorObject[]>([]);

    //布尔值变量。用于确认选择区域的弹窗是否显示
    const [imgAreaDragModalVisible, setImgAreaDragModalVisible] = useState<boolean>(false);

    const [base64Img, setBase64Img] = useState<string>(null);



    /**
     * 更新图元后更新传感器，当前做了视频流的切换
     */
    useEffect(() => {
        if (props.entityUuid && props.entityUuid.length > 0) {
            if (sensor && sensor.primitiveUuid === props.entityUuid) {
                return;
            }
            if (!showType) {
                setUrl(null);
            }
            getSensorByPrimitiveUuid(props.entityUuid).then(res => {
                if (res.status === 200) {
                    let data: Sensor = res.data;
                    setSensor(data);
                    if (data.sensorParameters && data.sensorParameters.length > 0) {
                        let paramId = data.sensorParameters[data.sensorParameters.length - 1].id;
                        if (showType) {
                            queryCameraPlay(data.id, paramId).then(res2 => {
                                if (res2.status && res2.data) {
                                    // setUrl(res2.data.flv);
                                    setUrl(res2.data.https_flv.replace(/47.100.117.212:7443/g, "flv.tncet.com"));
                                    //TODO 线上部署需要用：  res.data.https_flv.replace(/47.100.117.212:7443/g, "flv.tncet.com")
                                } else {
                                    setUrl(null);
                                }
                            });
                        }
                    }
                }
            })
        }

    }, [props.entityUuid])

    useEffect(() => {
        generateData()
    }, [sensor])

    /**
     * 初始化数据
     * @returns 
     */
    const generateData = () => {
        if (sensor == null || sensor.id == null) return;
        getMonitorObjectsBySensorId(sensor.projectId, sensor.id).then(res => {
            let mobjects: MonitorObject[] = res.data || [];
            setMobjects(mobjects);
        })
    }


    useEffect(() => {
        if (showType) {
            if (!url) {
                if (sensor && sensor.id && sensor.sensorParameters && sensor.sensorParameters.length > 0) {
                    let paramId = sensor.sensorParameters[0].id;
                    queryCameraPlay(sensor.id, paramId).then(res2 => {
                        if (res2.status && res2.data) {
                            // setUrl("http://47.100.117.212:7080/rtp/0100000013100003.live.flv")
                            setUrl(res2.data.https_flv.replace(/47.100.117.212:7443/g, "flv.tncet.com"));
                            // TODO 线上部署需要用：  res.data.https_flv.replace(/47.100.117.212:7443/g, "flv.tncet.com")
                        }
                    })
                }
            }
        } else {


        }

    }, [showType])

    useEffect(() => {
        emitter.on(Emit_Event.LINE_CHART_UPDATE, generateData)

        return (() => {
            emitter.off(Emit_Event.LINE_CHART_UPDATE, generateData)
        })
    }, [sensor])






    return (
        <>
            <div className="device-code-area">
                <span className="device-code">
                    {sensor?.code || ''}
                </span>
                <div className="tabs">
                    <div className={classNames({
                        "tab": true,
                        "active": showType === ShowType.video
                    })} onClick={() => {
                        setShowType(ShowType.video);
                    }}>
                        <div className="text">视频</div>
                    </div>
                    <div className={classNames({
                        "tab": true,
                        "active": showType === ShowType.displacement
                    })} onClick={() => {
                        setShowType(ShowType.displacement);
                    }}>
                        <div className="text">位移</div>
                    </div>
                    <div className={classNames({
                        "tab": true,
                        "active": showType === ShowType.invasion
                    })} onClick={() => {
                        setShowType(ShowType.invasion);
                    }}>
                        <div className="text">异物</div>
                    </div>
                </div>
            </div>
            <div className="panel-item monitor-item" style={{ position: "relative" }}>
                {
                    (showType === ShowType.displacement || showType === ShowType.invasion)
                    &&
                    <div className="abs-button" onClick={() => { setImgAreaDragModalVisible(true); }}>
                        <Tooltip title='' placement="bottomLeft">
                            <SwitchImgAndVideoSvg />
                        </Tooltip>
                    </div>
                }

                {
                    showType === ShowType.video &&
                    <MonitorVideoPanel
                        url={url}
                        sensor={sensor}
                    />}

                {
                    showType === ShowType.displacement &&
                    <MonitorImagePanel
                        sensor={sensor}
                        setImg={(img) => { setBase64Img(img) }}
                    />
                }

                {
                    showType === ShowType.invasion &&
                    <MonitorInvasionPanel
                        sensor={sensor}
                        setImg={(img) => { setBase64Img(img) }}
                    />
                }
            </div>
            <div className="panel-item monitor-item">
                <MonitorCurvePanel monitorObjects={mobjects} />
            </div>
            <div className="panel-item monitor-item">
                <MonitorSettingPanel monitorObjects={mobjects} sensor={sensor} />
            </div>



            <DragModal
                mask
                centered
                title="选择区域"
                visible={imgAreaDragModalVisible}
                width={550}
                wrapClassName="img-area-drag-modal"
                onClose={() => setImgAreaDragModalVisible(false)}>
                <div className="img-area-drag-modal-body">
                    <Base64ImageCanvas
                        canvasHeight={297}
                        canvasWidth={528}
                        sensorParamId={sensor?.sensorParameters?.filter(item => item.symbol === "video")[0]?.id}
                        base64String={base64Img}
                        onCancel={() => {
                            setImgAreaDragModalVisible(false);
                        }}
                        onConfirm={(area) => {
                            setImgAreaDragModalVisible(false);
                            const allPolygons = area; // 现在area是多边形数组，每个多边形是一个顶点数组

                            // 如果需要计算所有多边形的整体边界框
                            const allPoints = allPolygons.flat(); // 将所有多边形的顶点合并成一个数组
                            const data = {
                                polygons: allPolygons, // 传递所有多边形
                                points: allPoints,     // 所有顶点的扁平数组（保持向后兼容）
                            }
                            if (showType === ShowType.displacement) {
                                const videoParams = sensor.sensorParameters.filter(item => item.symbol === "video");
                                data['type'] = "match-range"
                                mobjects?.forEach(mobj => {
                                    mobj.rootMonitorParameters?.forEach(mobjParam => {
                                        if (mobjParam.symbol === "deform") {
                                            data['param_id'] = mobjParam.id;
                                        }
                                    })
                                });
                                if (videoParams.length > 0) {
                                    let paramIds = []
                                    videoParams.forEach(videoParam => {
                                        if (videoParam?.id) {
                                            paramIds.push(videoParam.id)
                                        }
                                    })
                                    data['video_param_ids'] = paramIds;
                                }
                                console.log("data", data)

                            } else if (showType === ShowType.invasion) {
                                // const invasionParams = sensor.sensorParameters.filter(item => item.symbol === "invasion_image");
                                // data['type'] = "invasion-range";
                                // data['id'] = sensor.id;
                                // if (invasionParams.length > 0) {
                                //     let paramId = invasionParams[0].id;
                                //     data['param_id'] = paramId;
                                // }
                                // mobjects?.forEach(mobj => {
                                //     mobj.rootMonitorParameters?.forEach(mobjParam => {
                                //         if (mobjParam.symbol === "invasion_size") {
                                //             data['obj_param_id'] = mobjParam.id;
                                //         }
                                //     })
                                // });
                                // TODO 暂时先return
                                return;
                            }
                            sendRangeToAiServer(sensor?.id, data).then(res => {
                                if (res.data) {
                                    message.success("设置成功");
                                }
                                console.log("调用 sendRangeToAiServer，传输的数据：", {
                                    sensorId: sensor?.id,
                                    data: data
                                });
                            })
                        }}
                    />
                </div>
            </DragModal>

        </>
    )
}
